import {initialize, getActiveLanguage, addTranslation, setActiveLanguage} from 'react-localize-redux';

export const COMMON_REQ = 'cris/locale/COMMON_REQ';
export const COMMON_REQ_SUCCESS = 'cris/locale/COMMON_REQ_SUCCESS';
export const COMMON_REQ_FAIL = 'cris/locale/COMMON_REQ_FAIL';

// actions
export const loadLanguage = (file) => {
	return (dispatch) => {
		dispatch(addTranslation(file));
	}
};

export const switchLanguage = (localeCode) => {
	return (dispatch, getState) => {
		const availableLocales = ['en', 'es'];
		const {locale} = getState();
		const activeLocale = getActiveLanguage(locale).code;
		if(localeCode !== activeLocale && availableLocales.includes(localeCode)) {
			dispatch(setActiveLanguage(localeCode));
			dispatch({
				types: [COMMON_REQ, COMMON_REQ_SUCCESS, COMMON_REQ_FAIL],
				promise: (client) => client.get(`/auth/change-language/${localeCode}`, {}),
			});
		}
	}
};

export const initializeLanguage = () => {
	return (dispatch) => {
		const availableLocales = ['en', 'es'];
		const activeLocale = 'en';

		const transformFunction = (translationData, languageCodes) => {
			return Object.keys(translationData).reduce((prev, cur, index) => {
				const languageData = translationData[cur];
				for(let prop in languageData) {
					if(typeof languageData[prop] === 'string') {
						const values = prev[prop] || [];
						prev[prop] = languageCodes.map((code, languageIndex) => {
							return index === languageIndex ? languageData[prop] : values[languageIndex];
						});
					}
					else {
						prev[prop] = prev[prop] || {};
						for(let childProp in languageData[prop]) {
							const childValues = prev[prop][childProp] || [];
							prev[prop][childProp] = languageCodes.map((code, languageIndex) => {
								return index === languageIndex ? languageData[prop][childProp] : childValues[languageIndex];
							});
						}
					}
				}

				return prev;
			}, {});
		};

		dispatch(initialize(availableLocales, {
			defaultLanguage: activeLocale,
			missingTranslationMsg: '',
			translationTransform: transformFunction
		}));
	}
};